export enum AccountType {
  User = "User",
  Entity = "Entity",
}